import React from 'react'

import { formatTokenBalance, fromTokenNameToDecimals, fromTokenNameToAddress, fromTokenNameToIcon } from '../tokenUtilities.js'
import { poolConfigs, rewardToken, tokenConfigs } from './contractConfigs.js';
import { scannerBaseURLByChain, getActionLink, getDexNativeSymbol } from './ChainTools.js'
import { SvgContainer } from './SvgContainer'
//formatTokenBalance(fromTokenNameToDecimals(poolConfigs["0"]["stake-name"]), poolBalanceYOMOPU)
const p = (x, y) => x + " " + y
const p0 = p(0,0)
const pointArrayRectangle = (xMax, yMax) => {
      return [
         p(0,0), 
         p(xMax,0), 
         p(xMax,yMax), 
         p(0,yMax)
      ]
    }

    const morph = {p:0, newP: "p(0,0)"}
export function Pool (props) {
    const thePool = poolConfigs[props.poolID]
    const thePoolTokenName = poolConfigs[props.poolID]["stake-name"]
    const thePoolFee = poolConfigs[props.poolID]["fee"]
    const thePoolRate = poolConfigs[props.poolID]["rate"]
    const thePoolAddy = fromTokenNameToAddress(thePoolTokenName)
    const xMax = 640;
    const yMax = xMax;
    var ps = pointArrayRectangle(xMax, yMax)
    var points = ps.join(" ")
    var psB = ps
    psB[morph["p"]] = eval(morph["newP"]) 
    var pointsB =  psB.join(" ")
    let tokenA = getDexNativeSymbol(thePool["dex"])
    let tokenB = thePoolAddy
    if (thePool["action"] === "add") {
      tokenA = thePool["pairA"]
      tokenB = thePool["pairB"]
    }


    return ( 
      <div className={"pool poolsvg--" + ((props.svgContainer) ? "true" : "false") + " pool--" + thePool["status"] + " poolrate--" + thePool["rate"]}>
        {(props.svgContainer) ? <SvgContainer 
                                  id={props.poolID} 
                                  w="640" h="640" 
                                  points={points} 
                                  pointsEnd={pointsB}
                                  turbScale="64" 
                                  turbFreq="0.01" 
                                  octaves="2"
                                  grad={false} /> : ""}
        <div className="pool__name">
          <span>Stake: 
            <a href={getActionLink(props.chainId, thePool["dex"], thePool["action"],tokenA,tokenB)} target="_blank">
              <img className={thePoolTokenName}  src={fromTokenNameToIcon(thePoolTokenName)["default"]} /></a></span>
          <span className="arrows"> {"\>\>"} </span>
          <span>Earn: <img src={rewardToken["icon"]["default"]} /></span>
        </div>
        <div className="pool__textName">{thePool["name"]}</div>
        <div className="pool__balance">
          Balance: <strong>{
            formatTokenBalance(
              fromTokenNameToDecimals(thePoolTokenName), 
              props.balance)}</strong>
        </div>
        <div className="pool__rewards">Pending: <strong>{formatTokenBalance(18, props.rewards)}</strong></div>
        <div className="pool__depositFee">Deposit Fee: <strong>{thePoolFee}%</strong></div>
        <div className="pool__controls">
          <a href={scannerBaseURLByChain(props.chainId) + "/token/" + fromTokenNameToAddress(thePoolTokenName)} target="_blank">CONTRACT</a>
          <button className="pool__btn" onClick={props.minusFunction}>
            -
          </button>
          <button className="pool__btn" onClick={props.plusFunction}>
            +
          </button>
          <button className="pool__btn" onClick={props.harvestFunction}>
            Harvest
          </button>
        </div>
        <div className="pool__rate">{formatTokenBalance(0, (props.emissionRate / 10 ** 18) *( thePoolRate/props.totalAllocPoints))} {rewardToken["name"]}/block</div>
        <div className="pool__locked">{/*formatTokenBalance(
              fromTokenNameToDecimals(thePoolTokenName), 
              props.lockedBalance)*/}</div>
      </div>
    )
    
  } 